<template>
  <div class="mod-overlay" @click.self="$emit('close')">
    <div class="mod-modal">
      <!-- Header -->
      <div class="mod-modal-header">
        <h3 class="mod-modal-title">
          <i :class="isEdit ? 'bi bi-pencil' : 'bi bi-plus-circle'"></i>
          {{ isEdit ? 'Editar mapeo' : 'Nuevo mapeo' }}
        </h3>
        <button class="mod-modal-close" @click="$emit('close')">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <!-- Body -->
      <form @submit.prevent="handleSubmit" class="mod-modal-body">
        <!-- Error -->
        <div v-if="error" class="mod-alert-error">
          <i class="bi bi-exclamation-triangle-fill"></i>
          {{ error }}
        </div>

        <div class="mod-form-grid">
          <!-- ErpId -->
          <div class="mod-field">
            <label for="ErpId">ERP <span class="mod-required">*</span></label>
            <input
              type="text"
              id="ErpId"
              v-model="form.ErpId"
              :disabled="isEdit"
              required
              maxlength="50"
              placeholder="Identificador del ERP"
            >
          </div>

          <!-- ObjetoId -->
          <div class="mod-field">
            <label for="ObjetoId">Objeto</label>
            <input
              type="number"
              id="ObjetoId"
              v-model.number="form.ObjetoId"
              :disabled="isEdit"
              placeholder="ID del objeto"
            >
          </div>

          <!-- CampoGestion360 -->
          <div class="mod-field">
            <label for="CampoGestion360">Campo Gestión 360 <span class="mod-required">*</span></label>
            <input
              type="text"
              id="CampoGestion360"
              v-model="form.CampoGestion360"
              :disabled="isEdit"
              required
              placeholder="Nombre del campo en Gestión 360"
            >
          </div>

          <!-- CampoErp -->
          <div class="mod-field">
            <label for="CampoErp">Campo ERP</label>
            <input
              type="text"
              id="CampoErp"
              v-model="form.CampoErp"
              placeholder="Nombre del campo en ERP"
            >
          </div>

          <!-- Transformacion -->
          <div class="mod-field">
            <label for="Transformacion">Transformación</label>
            <input
              type="text"
              id="Transformacion"
              v-model="form.Transformacion"
              placeholder="Regla de transformación"
            >
          </div>
        </div>

        <!-- Footer -->
        <div class="mod-modal-footer">
          <button type="button" class="mod-btn mod-btn-cancel" @click="$emit('close')">
            Cancelar
          </button>
          <button type="submit" class="mod-btn mod-btn-save" :disabled="saving">
            <span v-if="saving" class="mod-spinner-sm"></span>
            <template v-else>
              <i class="bi bi-check-lg"></i>
              {{ isEdit ? 'Guardar cambios' : 'Crear mapeo' }}
            </template>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import mapeoerpService from './mapeoerp.service';
import { showToast } from '@/shared/utils/toast';
import { createMapeoErp } from './mapeoerp.model';

export default {
  name: 'MapeoErpForm',
  props: {
    item: { type: Object, default: null },
    isEdit: { type: Boolean, default: false }
  },
  emits: ['saved', 'close'],
  data() {
    return {
      form: createMapeoErp(),
      saving: false,
      error: null
    };
  },
  created() {
    if (this.isEdit && this.item) {
      this.form = { ...this.item };
    }
  },
  methods: {
    async handleSubmit() {
      this.saving = true;
      this.error = null;

      if (!this.form.ErpId || !this.form.CampoGestion360) {
        this.error = 'ERP y Campo Gestión 360 son obligatorios';
        this.saving = false;
        return;
      }

      try {
        const result = await mapeoerpService.guardar(this.form);
        if (result.Number >= 0) {
          showToast(result.Message || 'Guardado correctamente', result.Type || 'success');
          this.$emit('saved');
        } else {
          this.error = result.Message || 'Error al guardar';
        }
      } catch (e) {
        console.error('Error al guardar:', e);
        this.error = 'Error de conexion con el servidor';
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
@import "@/modules/_shared/catalog.css";
</style>
